import { Box, styled } from '@mui/material';
import { ChildrenProps } from '@dfl/mui-react-common';
import { useLocation } from 'react-router';
import { useMemo } from 'react';

const AdminLayoutRoot = styled('div')<{ pl: number }>(({ theme, pl }) => ({
  display: 'flex',
  flex: '1 1 auto',
  maxWidth: '100%',
  paddingTop: 64,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: pl || 280,
  },
}));

export const RootAdminMain = ({ children, pl }: ChildrenProps & { pl: number }) => {
  const { pathname } = useLocation();

  const paddingX = useMemo(() => {
    if (pathname === '/reports/inventory/logistics-location') return 0;
    return { xs: '8px', md: '20px' };
  }, [pathname]);

  return (
    <AdminLayoutRoot pl={pl}>
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          width: '100%',
          paddingX,
        }}
      >
        {children}
      </Box>
    </AdminLayoutRoot>
  );
};
